module.exports = __webpack_public_path__ + "static/media/form-checkbox-checked.b6e1922e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/Checkbox/assets/form-checkbox-checked.svg
// module id = 2432
// module chunks = 193